<script>
export default {
    name: "ArrowRightSvg"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="10.356" height="28.292" viewBox="0 0 10.356 28.292">
        <g id="Group_284" data-name="Group 284" transform="translate(0)">
            <g id="Polygon_2" data-name="Polygon 2" transform="translate(10.356 28.292) rotate(180)" fill="none">
                <path d="M5.178,0l5.178,8.8H0Z" stroke="none"/>
                <path d="M 5.177799224853516 1.972293853759766 L 1.748415946960449 7.802219867706299 L 8.607182502746582 7.802219867706299 L 5.177799224853516 1.972293853759766 M 5.177799224853516 0 L 10.35559940338135 8.802219390869141 L -9.5367431640625e-07 8.802219390869141 L 5.177799224853516 0 Z" stroke="none" fill="#fff"/>
            </g>
            <path id="Path_243" data-name="Path 243" d="M28.033,0H0" transform="translate(5.178 0) rotate(90)" fill="none" stroke="#fff" stroke-width="1"/>
        </g>
    </svg>
</template>
